"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationQuestion {
  static thaw(evaluationQuestionObj) {
    if (evaluationQuestionObj == null) return null;
    const evaluationQuestion = new EvaluationQuestion();
    if (evaluationQuestionObj.id != null) evaluationQuestion.setId(evaluationQuestionObj.id);
    if (evaluationQuestionObj.question != null) evaluationQuestion.setQuestion(evaluationQuestionObj.question);
    if (evaluationQuestionObj.problem != null) evaluationQuestion.setProblem(evaluationQuestionObj.problem);
    if (evaluationQuestionObj.type != null) evaluationQuestion.setType(evaluationQuestionObj.type);
    if (evaluationQuestionObj.sortOrder != null) evaluationQuestion.setSortOrder(evaluationQuestionObj.sortOrder);
    if (evaluationQuestionObj.isActive != null) evaluationQuestion.setIsActive(evaluationQuestionObj.isActive == null ? null : evaluationQuestionObj.isActive ? true : false);
    if (evaluationQuestionObj.evaluationVersionId != null) evaluationQuestion.setEvaluationVersionId(evaluationQuestionObj.evaluationVersionId);
    if (evaluationQuestionObj.sectionId != null) evaluationQuestion.setSectionId(evaluationQuestionObj.sectionId);
    if (evaluationQuestionObj.parentQuestionId != null) evaluationQuestion.setParentQuestionId(evaluationQuestionObj.parentQuestionId);
    if (evaluationQuestionObj.parentQuestion != null) evaluationQuestion.setParentQuestion(EvaluationQuestion.thaw(evaluationQuestionObj.parentQuestion));
    if (evaluationQuestionObj.childQuestions != null) evaluationQuestion.setChildQuestions(EvaluationQuestion.thawList(evaluationQuestionObj.childQuestions));
    if (evaluationQuestionObj.evaluationVersion != null) evaluationQuestion.setEvaluationVersion(_.EvaluationVersion.thaw(evaluationQuestionObj.evaluationVersion));
    if (evaluationQuestionObj.remedies != null) evaluationQuestion.setRemedies(_.EvaluationRemedy.thawList(evaluationQuestionObj.remedies));
    if (evaluationQuestionObj.answer != null) evaluationQuestion.setAnswer(_.EvaluationQuestionAnswer.thaw(evaluationQuestionObj.answer));
    return evaluationQuestion;
  }

  static thawList(evaluationQuestionObjList) {
    if (evaluationQuestionObjList == null) return [];
    var evaluationQuestions = [];

    for (var i = 0; i < evaluationQuestionObjList.length; i++) {
      evaluationQuestions.push(EvaluationQuestion.thaw(evaluationQuestionObjList[i]));
    }

    return evaluationQuestions;
  }

  static freeze(evaluationQuestion) {
    if (evaluationQuestion == null) return null;
    var evaluationQuestionObj = {};
    if (evaluationQuestion.getId() != null) evaluationQuestionObj.id = evaluationQuestion.getId();
    if (evaluationQuestion.getQuestion() != null) evaluationQuestionObj.question = evaluationQuestion.getQuestion();
    if (evaluationQuestion.getProblem() != null) evaluationQuestionObj.problem = evaluationQuestion.getProblem();
    if (evaluationQuestion.getType() != null) evaluationQuestionObj.type = evaluationQuestion.getType();
    if (evaluationQuestion.getSortOrder() != null) evaluationQuestionObj.sortOrder = evaluationQuestion.getSortOrder();
    if (evaluationQuestion.getIsActive() != null) evaluationQuestionObj.isActive = evaluationQuestion.getIsActive() == null ? null : evaluationQuestion.getIsActive() ? 1 : 0;
    if (evaluationQuestion.getEvaluationVersionId() != null) evaluationQuestionObj.evaluationVersionId = evaluationQuestion.getEvaluationVersionId();
    if (evaluationQuestion.getSectionId() != null) evaluationQuestionObj.sectionId = evaluationQuestion.getSectionId();
    if (evaluationQuestion.getParentQuestionId() != null) evaluationQuestionObj.parentQuestionId = evaluationQuestion.getParentQuestionId();
    if (evaluationQuestion.getParentQuestion() != null) evaluationQuestionObj.parentQuestion = EvaluationQuestion.freeze(evaluationQuestion.getParentQuestion());
    if (evaluationQuestion.getChildQuestions() != null) evaluationQuestionObj.childQuestions = EvaluationQuestion.freezeList(evaluationQuestion.getChildQuestions());
    if (evaluationQuestion.getEvaluationVersion() != null) evaluationQuestionObj.evaluationVersion = _.EvaluationVersion.freeze(evaluationQuestion.getEvaluationVersion());
    if (evaluationQuestion.getRemedies() != null) evaluationQuestionObj.remedies = _.EvaluationRemedy.freezeList(evaluationQuestion.getRemedies());
    if (evaluationQuestion.getAnswer() != null) evaluationQuestionObj.answer = _.EvaluationQuestionAnswer.freeze(evaluationQuestion.getAnswer());
    return evaluationQuestionObj;
  }

  static freezeList(evaluationQuestions) {
    if (evaluationQuestions == null) return [];
    var evaluationQuestionObjList = [];

    for (var i = 0; i < evaluationQuestions.length; i++) {
      evaluationQuestionObjList.push(EvaluationQuestion.freeze(evaluationQuestions[i]));
    }

    return evaluationQuestionObjList;
  }

  constructor() {
    this.setId(null);
    this.setQuestion(null);
    this.setProblem(null);
    this.setType(null);
    this.setSortOrder(null);
    this.setIsActive(null);
    this.setEvaluationVersionId(null);
    this.setSectionId(null);
    this.setParentQuestionId(null);
    this.setParentQuestion(null);
    this.setChildQuestions(null);
    this.setEvaluationVersion(null);
    this.setRemedies(null);
    this.setAnswer(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setQuestion(question) {
    this.question = question;
  }

  setProblem(problem) {
    this.problem = problem;
  }

  setType(type) {
    this.type = type;
  }

  setSortOrder(sortOrder) {
    this.sortOrder = sortOrder;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setEvaluationVersionId(evaluationVersionId) {
    this.evaluationVersionId = evaluationVersionId;
  }

  setSectionId(sectionId) {
    this.sectionId = sectionId;
  }

  setParentQuestionId(parentQuestionId) {
    this.parentQuestionId = parentQuestionId;
  }

  setParentQuestion(parentQuestion) {
    this.parentQuestion = parentQuestion;
  }

  setChildQuestions(childQuestions) {
    this.childQuestions = childQuestions;
  }

  setEvaluationVersion(evaluationVersion) {
    this.evaluationVersion = evaluationVersion;
  }

  setRemedies(remedies) {
    this.remedies = remedies;
  }

  setAnswer(answer) {
    this.answer = answer;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getQuestion() {
    return this.question;
  }

  getProblem() {
    return this.problem;
  }

  getType() {
    return this.type;
  }

  getSortOrder() {
    return this.sortOrder;
  }

  getIsActive() {
    return this.isActive;
  }

  getEvaluationVersionId() {
    return this.evaluationVersionId;
  }

  getSectionId() {
    return this.sectionId;
  }

  getParentQuestionId() {
    return this.parentQuestionId;
  }

  getParentQuestion() {
    return this.parentQuestion;
  }

  getChildQuestions() {
    return this.childQuestions;
  }

  getEvaluationVersion() {
    return this.evaluationVersion;
  }

  getRemedies() {
    return this.remedies;
  }

  getAnswer() {
    return this.answer;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationQuestion;